import toast from "react-hot-toast";

const HandleException = (err) => {
  console.log(err, "from handleException");
  try {
    if (err?.response?.data) {
      let { data, status, statusText, config, headers, request } = err.response;
      if (status == 400) {
        toast.error(data?.message);
        return data;
      } else if (status == 401) {
        toast.error("You have already logged in another device");
        setTimeout(() => {
          localStorage.clear();
          window.location.href = "/";
        }, 2000);
      } else if (status == 404) {
        toast.error("Page Not Found");
      } else {
        toast.error(`status  retruns ${data?.message}`);
      }
    } else {
      toast.error("Something went wrong check or check your internet");
    }
  } catch (error) {
    toast.error("Someting went wrong or check your internet");
  }
  return {};
};

export default HandleException;
